import React, { useEffect, useState } from "react";
import {getDomainByID} from "../../api/domaines";
import { useParams } from "react-router-dom";
export default function DomainList({ onEdit }) {

  const [domains, setDomains] = useState([]);


  const { id } = useParams();

  const loadDomains = async (url) => {
    console.log('id',id); // 👉 "1"

    const data = await getDomainByID(url,id);
    console.log("datadata",data);
    setDomains(data);
  };
  useEffect(() => {
    loadDomains(); // page 1 par défaut
  }, []);

  return (
    <div>
      <h2>Liste des Domaines</h2>

      {/* TABLE */}
      <table>
        <thead>
        <tr>
          <th>Domaine</th>
          <th>Fiches</th>
          <th>Abonnés</th>
          <th>Collège</th>
          <th>Sous-domaines</th>
          <th>Actions</th>
        </tr>
        </thead>

        <tbody>
          <tr>
            <td>{domains.domLib}</td>
            <td>{domains.domNbPrescripteurs}</td>
            <td>{domains.domNbPrescripteurs}</td>
            <td>{domains?.ste?.steLib}</td>
            <td></td>
            <td>
              <button className="fr-btn" onClick={() => onEdit(domains)}>Modifier</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
